export default {
  INSERT: 'insert',
  UPDATE: 'update',
};

